/* src/utils/ensureMyWorkspace.js — create the caller's own workspace doc if absent */

import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

export async function ensureMyWorkspace(currentUser) {
  if (!currentUser?.uid) throw new Error('Not signed in');

  const ref = doc(db, 'workspaces', currentUser.uid);

  return runTransaction(db, async (transaction) => {
    const snap = await transaction.get(ref);
    if (snap.exists()) {
      return currentUser.uid;
    }

    transaction.set(ref, {
      ownerId: currentUser.uid,
      name: 'My Workspace',
      members: [],
      createdAt: serverTimestamp(),
    });

    return currentUser.uid;
  });
}
